export default __webpack_public_path__ + "static/char-s-58-zh-Hant-64d41e2a52eb185a4056f2f6881ad818.webp";